import { render } from "./form-divider.vue?vue&type=template&id=d8154e96"
import script from "./form-divider.vue?vue&type=script&lang=js"
export * from "./form-divider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__